<template lang="pug">
div
  screen-title(title="online_booking.deposits_title")
  
  .box
    
    //p.subtitle.is-6 {{ $t('online_booking.deposits_subtitle') }}
    b-field
      b-switch(v-model="deposit.active" type="is-success") {{deposit.active ? $t('online_booking.deposit_enabled') : $t('online_booking.deposit_disabled')}}
    b-field(:label="$t('online_booking.deposit_default_ratio')")
      b-select(v-model="deposit.defaultRatio")
        option(v-for="ratio in Object.values(DEPOSIT_GROUP)" :key="ratio" :value="ratio") {{$t(`deposit_ratio.${ratio}`)}}

  .buttons.mt-4
    action-button(title="actions.save" @click="submit" :loading="submitting" :permission="PERMISSIONS.core.COMPANY_SETTINGS_EDIT" scope)
</template>

<script>
import {mapState} from 'vuex'

import DEPOSIT_GROUP from '../../../constants/depositGroup'
import PERMISSIONS from '../../../constants/permissions'
export default {
  name: 'OnlineBookingSettings',

  data() {
    return {
      DEPOSIT_GROUP,
      submitting: false,
      PERMISSIONS,

      deposit: {
        active: false,
        defaultRatio: DEPOSIT_GROUP.FULL,
        cancelationPolicy: 24,
        policyText: {},
        cancelByCustomer: false
      }
    }
  },
  computed: {
    ...mapState('company', ['company'])
  },
  created() {
    this.deposit = (this.company.deposit && Object.assign({}, this.company.deposit)) || this.deposit
    this.deposit.policyText = this.deposit.policyText || {}
  },
  methods: {
    async submit() {
      if (this.submitting) return

      this.submitting = true
      const valid = await this.$validator.validateAll()
      if (!valid) {
        this.submitting = false
        return
      }

      const data = {
        deposit: this.deposit
      }
      try {
        await this.$store.dispatch('company/update', data)
        this.$buefy.toast.open({message: this.$t('status.save_success'), type: 'is-success', queue: false})
        this.$emit('saved')
      } catch (error) {
        this.$handleAPIError(error)
      }
      this.submitting = false
    }
  }
}
</script>
